<template>
    <div class="container">
        <p v-show="loading">Loading...</p>
        <div v-show="posts">
			<div class="grid-x grid-margin-x grid-margin-y">
				<div class="small-12 medium-6 large-4 cell grid-x align-stretch" v-for="post in posts">
                    <single-post-component :post="post"></single-post-component>
                </div>
			</div>
		</div>
    </div>
</template>

<script>
    import SinglePostComponent from "./SinglePostComponent.vue";
    export default {
        mounted() {
            this.getPosts();
    	},
        components: {
            SinglePostComponent
        },
        props: ["endpoint"],
        data() {
        	return {
	        	posts: false,
	    		loading: false,
                order: 'desc',
                orderBy: 'date'
	        }
        },
        methods: {
        	getPosts() {
                // setting loading state before
        		this.loading = true;

        		this.$http.get(this.rest_endpoint, {
			    	params: {
                        order: this.order,
                        orderby: this.orderBy
                    }
			  	})
			  	.then((response) => {
                    // getting response and setting this.posts
			    	this.posts = response.data;
			    	this.loading = false;
			  	})
			  	.catch(function (error) {
			    	// catch error
		  		});
        	}
        },
        computed: {
            rest_endpoint() {
                return "/"+this.endpoint;
            }
        }
    }
</script>
